import React, { useState, useCallback, useMemo } from 'react';
import cn from 'classnames';
import { Modal, CloseButton, Image } from '@landing/ui';
import { Slider, CustomDot, CustomPagination } from 'components/Slider';
import GalleryVideo from './GalleryVideo';

import * as styles from './GalleryModal.module.scss';

export default function GalleryModal({ items, index = 0, name, year, theme, ...props }) {
  const [current, setCurrent] = useState(index);
  const isVertical = theme === 'vertical';

  const setCurrentIndex = useCallback((prev, next) => {
    setCurrent(next);
  }, []);

  const settings = useMemo(
    () => ({
      customPaging: CustomDot.bind(null, items.length, current),
      appendDots: CustomPagination,
      dotsClass: 'slick-pagination',
      dots: true,
      speed: 1000,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: index,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
          },
        },
        {
          breakpoint: 544,
          settings: {
            adaptiveHeight: true,
            arrows: false,
          },
        },
      ],
    }),
    [items.length, current, index],
  );

  return (
    <Modal
      closeButton={false}
      theme={isVertical ? 'galleryOwlSoulVertical' : 'galleryOwlSoul'}
      containerMod="wide"
      contentMod="noPadding"
      animation="opacity"
      {...props}
    >
      {onClose => (
        <div className={cn(styles.content, theme && styles[theme])}>
          <CloseButton onClose={onClose} theme="light" className={styles.closeButton} />
          <div className={cn(styles.slider, 'gallerySlider')}>
            <Slider beforeChange={setCurrentIndex} {...settings}>
              {items.map(({ popupImage, videoSrc }, i) => (
                <React.Fragment key={i}>
                  {videoSrc ? (
                    <GalleryVideo src={videoSrc} index={i} current={current} />
                  ) : (
                    <Image src={popupImage} className={styles.picture} classImage={styles.image} />
                  )}
                </React.Fragment>
              ))}
            </Slider>
          </div>
          {name && (
            <div className={styles.caption}>
              <div className={styles.name}>{name}</div>
              <div className={styles.year}>{year}</div>
            </div>
          )}
        </div>
      )}
    </Modal>
  );
}
